import { JobOffer } from '@dinosband/bv-main-schema/dist/types'
import { Store as MainStore, subscribeOnJobOfferOfResponseUpdated, subscribeOnJobOfferUpdated } from '@dinosband/bv-main-client'
import { BvSubscriber } from './manager/subscriber'

export class JobOfferSubscriber extends BvSubscriber<JobOffer> {

  mainStore: MainStore
  userId?: number
  jobOfferId?: number
  // context?: ChatRoomContext

  constructor (mainStore: MainStore, userId: number | undefined, jobOfferId: number | undefined, callback: (value: JobOffer) => void) {
    super(callback as unknown as (value: JobOffer | JobOffer[]) => void)
    this.mainStore = mainStore
    this.userId = userId
    this.jobOfferId = jobOfferId
  }

  protected async query () {
    if (!this.jobOfferId) {
      return
    }
    const result = await this.mainStore.readJobOffersByIds([this.jobOfferId])
    return result?.[0]
  }

  protected async subscribe () {
    if (this.userId) {
      return await this.subscribeMyJobOffers()
    } else if (this.jobOfferId) {
      return await this.subscribeOneJobOffer(this.jobOfferId)
    }
  }

  private async subscribeOneJobOffer (jobOfferId: number) {
    return subscribeOnJobOfferOfResponseUpdated(await this.mainStore.apollo.getClient(), [jobOfferId], (value) => { this.callback(value) })
  }

  private async subscribeMyJobOffers () {
    const userId = this.mainStore.userId
    if (!userId) {
      return
    }
    return subscribeOnJobOfferUpdated(await this.mainStore.apollo.getClient(), [], userId, (value) => { this.callback(value) })
  }



}
